import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb1e9948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-photos-wrapper" }
const _hoisted_2 = { class: "d-photos-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "d-photos-header__title" }, "My Photos", -1))
const _hoisted_4 = { class: "d-photos-header__buttons" }
const _hoisted_5 = { class: "d-layout-switcher" }
const _hoisted_6 = { class: "buttons-back-link" }
const _hoisted_7 = { class: "buttons-done-button" }
const _hoisted_8 = {
  key: 0,
  class: "drop-zone"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-zone__body" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "drop-zone__icon icon icon-download" }),
  /*#__PURE__*/_createElementVNode("span", { class: "drop-zone__text" }, "Drop some files here")
], -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header_upload_progress = _resolveComponent("app-header-upload-progress")!
  const _component_app_skeleton_rect = _resolveComponent("app-skeleton-rect")!
  const _component_app_skeleton_media = _resolveComponent("app-skeleton-media")!
  const _component_item_photo = _resolveComponent("item-photo")!
  const _component_item_video = _resolveComponent("item-video")!
  const _component_app_no_message = _resolveComponent("app-no-message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.mainStore.uploadInfos.length)
        ? (_openBlock(), _createBlock(_component_app_header_upload_progress, {
            key: 0,
            uploadInfo: _ctx.mainStore.getUploadInfo
          }, null, 8, ["uploadInfo"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            class: _normalizeClass(["d-layout-switcher__btn icon", _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST ? 'active icon-list-view-2-active' : 'icon-list-view-2']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.driveStore.photoViewLayout = _ctx.PHOTO_VIEW_LAYOUT.LIST))
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass(["d-layout-switcher__btn icon", _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID_LABEL ? 'active icon-tiles-2-active' : 'icon-tiles-2']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.photoViewLayout = _ctx.PHOTO_VIEW_LAYOUT.GRID_LABEL))
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass(["d-layout-switcher__btn icon", _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID ? 'active icon-tiles-active' : 'icon-tiles']),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.driveStore.photoViewLayout = _ctx.PHOTO_VIEW_LAYOUT.GRID))
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]))
          }, _toDisplayString(_ctx.$localize('drive.view.add.photos.from.drive.backtext')), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            href: "javascript:void(0);",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('fileUpdate')), ["prevent"])),
            class: "link"
          }, _toDisplayString(_ctx.$localize('drive.done.button')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["scroll", {selector: _ctx.selector, 'scroll--hide-footer': _ctx.hideFooter}]),
      onScroll: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
      ref: "scroller"
    }, [
      (_ctx.photos.length || _ctx.dataLoading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref: "dropZoneRef",
            class: _normalizeClass(["item-wrapper", {
        'item-wrapper-grid': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID,
        'item-wrapper-list': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST,
        }])
          }, [
            (!_ctx.dataLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.isOverDropZone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoSkeletons, (n) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["item file-box", { 'item-grid': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID }]),
                      key: n
                    }, [
                      (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID)
                        ? (_openBlock(), _createBlock(_component_app_skeleton_rect, { key: 0 }))
                        : (_openBlock(), _createBlock(_component_app_skeleton_media, {
                            key: 1,
                            columnView: _ctx.column,
                            class: _normalizeClass({ 'is-mobile-skeleton': !_ctx.mainStore.isMobile })
                          }, null, 8, ["columnView", "class"]))
                    ], 2))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photos, (photo) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: photo.id + photo.fileUrl,
                      class: _normalizeClass([{ 'item-grid': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID }, "item"])
                    }, [
                      (photo.type === _ctx.MEDIA_TYPES.PHOTO)
                        ? (_openBlock(), _createBlock(_component_item_photo, {
                            key: 0,
                            photo: photo,
                            selector: _ctx.selector || _ctx.driveStore.isPhotoSelector,
                            "column-view": _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST
                          }, null, 8, ["photo", "selector", "column-view"]))
                        : _createCommentVNode("", true),
                      (photo.type === _ctx.MEDIA_TYPES.VIDEO)
                        ? (_openBlock(), _createBlock(_component_item_video, {
                            key: 1,
                            file: photo,
                            selector: _ctx.selector || _ctx.driveStore.isPhotoSelector,
                            "column-view": _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST,
                            thumbnail: ""
                          }, null, 8, ["file", "selector", "column-view"]))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.isPageLoading || _ctx.dataLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(27, (n) => {
                  return _createElementVNode("div", {
                    key: n,
                    class: _normalizeClass(["item", { 'item-grid': _ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID }])
                  }, [
                    ((_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID))
                      ? (_openBlock(), _createBlock(_component_app_skeleton_rect, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_app_skeleton_media, {
                          key: 1,
                          "column-view": (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.LIST)
                        }, null, 8, ["column-view"]))
                  ], 2)
                }), 64))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_app_no_message, {
        icon: _ctx.noPhotosMessage.icon
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.noPhotosMessage.text), 1)
        ]),
        _: 1
      }, 8, ["icon"]), [
        [_vShow, !_ctx.dataLoading && _ctx.noPhotosMessage && !_ctx.driveStore.photos.data]
      ])
    ], 34)
  ]))
}